import { supabase } from './api'

export const revalidate = 0

export async function uploadFile(filename, file) {
	const { data, error } = await supabase.storage.from('avatars').upload(filename, file, {
		upsert: true
	})

	if (error) {
		throw new Error('Failed to upload file')
	}

	return data
}

export async function getFile(filename) {
	const { data, error } = await supabase.storage.from('avatars').getPublicUrl(filename)

	if (error) {
		throw new Error('Failed to get file')
	}

	return data
}

export async function removeFile(filename) {
	const { data, error } = await supabase.storage.from('avatars').remove([filename])

	if (error) {
		throw new Error('Failed to remove file')
	}

	return data
}
